import { useTheme } from '@fluentui/react';
import React, { useState } from 'react';
import { Cell, LabelList, Pie, PieChart, Tooltip } from 'recharts';
import {
  Chart,
  ChartProps,
  currencyFormatter,
  useColors,
  useStyles,
} from '../common';
import { useHistory } from 'react-router-dom';
import { globalMode } from 'utility/cache/ui';
import clsx from 'clsx';
import { TransactionsChartData } from './__generated__/TransactionsChartData';

import query from './TransactionsChartData.graphql';
const Component: React.FC<ChartProps<TransactionsChartData>> = ({
  data,
  height,
  width,
}) => {
  const styles = useStyles();
  const theme = useTheme();
  const colors = useColors();
  const [activeIndex, setActiveIndex] = useState<number | undefined>(undefined);
  const [animation, setAnimation] = useState(true);
  const history = useHistory();

  return (
    <PieChart height={height} width={width}>
      <Pie
        data={data?.kpiTransactionTypes?.nodes}
        cx="50%"
        cy="50%"
        innerRadius={80}
        outerRadius={120}
        stroke={theme.palette.neutralLighterAlt}
        dataKey="amount"
        nameKey="title"
        paddingAngle={2}
        onMouseEnter={(_: any, index: number) => setActiveIndex(index)}
        onMouseLeave={(_: any, index: number) => {
          if (activeIndex === index) setActiveIndex(undefined);
        }}
        onClick={() => {
          if (activeIndex !== undefined) {
            globalMode(true);
            history.push(
              `signing?t=${data?.kpiTransactionTypes?.nodes[activeIndex].linkSearchValue}`
            );
          }
        }}
        className={clsx(activeIndex !== undefined && styles.pointer)}
        isAnimationActive={animation}
        onAnimationEnd={() => setAnimation(false)}
      >
        {data?.kpiTransactionTypes?.nodes?.map((_entry, index) => (
          <Cell
            key={`cell-${index}`}
            fill={colors[index % colors.length][index === activeIndex ? 1 : 0]}
          />
        ))}
        <LabelList
          position="outside"
          fill={theme.palette.neutralPrimary}
          stroke="none"
          dataKey="title"
          offset={15}
        />
      </Pie>
      <Tooltip
        formatter={(value: number) => currencyFormatter.format(value)}
        contentStyle={{
          backgroundColor: theme.palette.white,
          borderColor: theme.palette.neutralLighter,
        }}
        itemStyle={{
          color: theme.palette.neutralPrimary,
        }}
        isAnimationActive={false}
      />
    </PieChart>
  );
};

export const TransactionsChart: Chart<TransactionsChartData> = {
  Component,
  query,
  hasData: (data) => !!data.kpiTransactionTypes?.nodes.length,
};
